import { useCallback } from 'react';
import { Button } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { useSnapshot } from 'valtio';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import {
  FormContentContainer,
  FormFooterContainer,
  FormMainContainer,
} from '@duke-hq/ui/components/Modals/FormModalLayouts';
import type { RouterOutputs } from '@duke-hq/svc-api/provider';
import { CourseSegment, WorkSchedule } from '@duke-hq/shared-constants/enrolments';

import { CourseSelection } from '../../Courses/CourseSelection';
import { quickReferralModalState } from '../../tenantState/QuickReferralState';
import { ParticipantExistsAlert } from './ParticipantExistsAlert';

export function SelectCourse({
  goToNextStep,
  goToPrevStep,
}: {
  goToNextStep: () => void;
  goToPrevStep: () => void;
}) {
  const snap = useSnapshot(quickReferralModalState);
  const course = snap.courseData;
  const existingStudent =
    typeof snap.existingStudentId === 'string' ? { id: snap.existingStudentId } : undefined;

  const handleCourseChange = useCallback((course: RouterOutputs['courses']['all'][number]) => {
    quickReferralModalState.setCourseData({
      ...course,
      accredited: course.accredited ?? false,
    });

    // Reset enrolment state when course is changed
    quickReferralModalState.enrolmentSettingsData.course_segment = CourseSegment.FULL_COURSE;
    quickReferralModalState.enrolmentSettingsData.contract_category = '';
    quickReferralModalState.enrolmentSettingsData.enrolment_contract_type = '';
    quickReferralModalState.enrolmentSettingsData.work_schedule = WorkSchedule.FULL_TIME;
  }, []);

  return (
    <FormMainContainer>
      <FormContentContainer>
        <ParticipantExistsAlert />
        <CourseSelection course={course} student={existingStudent} onCourse={handleCourseChange} />
      </FormContentContainer>
      <FormFooterContainer>
        <Button
          rightIcon={<ChevronRightIcon />}
          onClick={goToNextStep}
          isDisabled={!snap.courseData?.id}
        >
          <Trans>Next</Trans>
        </Button>
        <Button onClick={goToPrevStep} variant="tertiary" leftIcon={<ChevronLeftIcon />}>
          <Trans>Back</Trans>
        </Button>
      </FormFooterContainer>
    </FormMainContainer>
  );
}
